import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 投票接口
 */
export class VoteControllerSvr {
  constructor() {
    this.baseurl = 'VoteControllerSvr.assx/';
  }

  /**
   * 自动投票
   * token:String, voteId:String
   */
  TestForVote(token, voteId) {
    return request.post(this.baseurl + 'TestForVote', Qs.stringify({
      token: token,
      voteId: voteId
    }));
  }

  /**
   * 添加投票
   * token:String, data:Vote
   */
  AddVote(token, data) {
    return request.post(this.baseurl + 'AddVote', Qs.stringify({
      token: token,
      data: typeof data === 'undefined' || data === null ? '' : data.toString()
    }));
  }

  /**
   * 根据条件获取投票列表
   * token:String, param:VoteQueryPara, detail:boolean, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetVoteList(token, param, detail, startIndex, maxSize, resultTotalCount) {
    return request.post(this.baseurl + 'GetVoteList', Qs.stringify({
      token: token,
      param: typeof param === 'undefined' || param === null ? '' : param.toString(),
      detail: detail,
      startIndex: startIndex,
      maxSize: maxSize,
      resultTotalCount: resultTotalCount
    }));
  }

  /**
   * 纸质投票
   * token:String, voteId:String
   */
  OfflineVote(token, voteId) {
    return request.post(this.baseurl + 'OfflineVote', Qs.stringify({
      token: token,
      voteId: voteId
    }));
  }

  /**
   * 获取半年内投票事项统计
   * token:String
   */
  GetVoteMatterStatistics(token) {
    return request.post(this.baseurl + 'GetVoteMatterStatistics', Qs.stringify({
      token: token
    }));
  }

  /**
   * 添加投票明细
   * token:String, data:VoteDetail
   */
  AddVoteDetail(token, data) {
    return request.post(this.baseurl + 'AddVoteDetail', Qs.stringify({
      token: token,
      data: typeof data === 'undefined' || data === null ? '' : data.toString()
    }));
  }

  /**
   * 获取投票对象
   * token:String, voteId:String, detail:boolean, child:boolean
   */
  GetVote(token, voteId, detail, child) {
    return request.post(this.baseurl + 'GetVote', Qs.stringify({
      token: token,
      voteId: voteId,
      detail: detail,
      child: child
    }));
  }
}